import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAnuncios } from '../hooks/useAnuncios';
import { CATEGORIAS } from '../types';
import AnuncioGrid from '../components/anuncios/AnuncioGrid';
import Button from '../components/common/Button';

const Home: React.FC = () => {
  const { destaques, recentes, carregarDestaques, carregarRecentes, isLoading } = useAnuncios();

  useEffect(() => {
    carregarDestaques();
    carregarRecentes();
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-800 via-green-700 to-amber-700 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }} />
        </div>
        
        <div className="container-custom py-16 md:py-24 relative">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              O Marketplace do <br />
              <span className="text-amber-300">Agronegócio Brasileiro</span>
            </h1>
            <p className="text-lg md:text-xl text-green-100 mb-8 max-w-2xl mx-auto">
              Compre e venda cavalos, gado, equipamentos e muito mais. 
              Conectamos produtores rurais de todo o Brasil.
            </p>
            
            {/* Search Bar */}
            <div className="bg-white rounded-xl p-2 shadow-xl max-w-2xl mx-auto">
              <form className="flex flex-col sm:flex-row gap-2">
                <div className="flex-1 relative">
                  <svg className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  <input
                    type="text"
                    placeholder="O que você está procurando?"
                    className="w-full pl-12 pr-4 py-3 text-gray-900 rounded-lg border-0 focus:ring-2 focus:ring-green-500 outline-none"
                  />
                </div>
                <Button as="link" href="/anuncios" size="lg">
                  Buscar
                </Button>
              </form>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap justify-center gap-8 md:gap-16 mt-12">
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-white">10K+</p>
                <p className="text-green-200 text-sm">Anúncios Ativos</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-white">5K+</p>
                <p className="text-green-200 text-sm">Vendedores</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-white">27</p>
                <p className="text-green-200 text-sm">Estados</p>
              </div>
            </div>
          </div>
        </div>

        {/* Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" className="w-full">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#F9FAFB"/>
          </svg>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title">Navegue por Categorias</h2>
            <p className="section-subtitle">Encontre o que você precisa de forma rápida e fácil</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {CATEGORIAS.slice(0, 5).map((categoria) => (
              <Link
                key={categoria.id}
                to={`/anuncios?categoria=${categoria.id}`}
                className="group bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <span className="text-5xl mb-4 block group-hover:scale-110 transition-transform duration-300">
                  {categoria.icone}
                </span>
                <h3 className="font-semibold text-gray-900 group-hover:text-green-700 transition-colors">
                  {categoria.nome}
                </h3>
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
            {CATEGORIAS.slice(5).map((categoria) => (
              <Link
                key={categoria.id}
                to={`/anuncios?categoria=${categoria.id}`}
                className="group bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <span className="text-5xl mb-4 block group-hover:scale-110 transition-transform duration-300">
                  {categoria.icone}
                </span>
                <h3 className="font-semibold text-gray-900 group-hover:text-green-700 transition-colors">
                  {categoria.nome}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Listings */}
      {destaques.length > 0 && (
        <section className="py-16">
          <div className="container-custom">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                  ⭐ Anúncios em Destaque
                </h2>
                <p className="text-gray-600 mt-1">Os melhores anúncios selecionados para você</p>
              </div>
              <Button as="link" href="/anuncios?destaque=true" variant="outline">
                Ver todos
              </Button>
            </div>

            <AnuncioGrid 
              anuncios={destaques.slice(0, 4)} 
              isLoading={isLoading}
              columns={4}
            />
          </div>
        </section>
      )}

      {/* Recent Listings */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                🆕 Anúncios Recentes
              </h2>
              <p className="text-gray-600 mt-1">Publicados recentemente na plataforma</p>
            </div>
            <Button as="link" href="/anuncios" variant="outline">
              Ver todos
            </Button>
          </div>

          <AnuncioGrid 
            anuncios={recentes} 
            isLoading={isLoading}
            columns={4}
            emptyMessage="Nenhum anúncio disponível no momento"
          />
        </div>
      </section>

      {/* How it Works */}
      <section className="py-16">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title">Como Funciona</h2>
            <p className="section-subtitle">Simples, rápido e seguro</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
                📝
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">1. Cadastre-se</h3>
              <p className="text-gray-600">
                Crie sua conta gratuitamente em poucos minutos e comece a explorar
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
                📸
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">2. Anuncie</h3>
              <p className="text-gray-600">
                Crie seu anúncio com fotos e descrição detalhada do seu produto
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
                🤝
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">3. Negocie</h3>
              <p className="text-gray-600">
                Entre em contato direto com compradores interessados e feche negócio
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-700">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Pronto para começar a vender?
            </h2>
            <p className="text-lg text-green-100 mb-8">
              Cadastre-se agora e publique seu primeiro anúncio gratuitamente
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button as="link" href="/registrar" variant="secondary" size="lg">
                Criar Conta Grátis
              </Button>
              <Button as="link" href="/planos" variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-green-700">
                Ver Planos
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl mb-3">🔒</div>
              <h4 className="font-semibold text-gray-900 mb-1">Segurança</h4>
              <p className="text-sm text-gray-600">Transações protegidas e vendedores verificados</p>
            </div>
            <div>
              <div className="text-4xl mb-3">💬</div>
              <h4 className="font-semibold text-gray-900 mb-1">Suporte</h4>
              <p className="text-sm text-gray-600">Atendimento dedicado para ajudar você</p>
            </div>
            <div>
              <div className="text-4xl mb-3">🚀</div>
              <h4 className="font-semibold text-gray-900 mb-1">Velocidade</h4>
              <p className="text-sm text-gray-600">Anuncie em minutos e encontre compradores rápido</p>
            </div>
            <div>
              <div className="text-4xl mb-3">🌎</div>
              <h4 className="font-semibold text-gray-900 mb-1">Alcance Nacional</h4>
              <p className="text-sm text-gray-600">Conecte-se com compradores de todo o Brasil</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
